export const LOGS_CONST = {
  DEFAULT_ADVANCED_QUERY: 'SELECT rawlogs.document, rawlogs.source, rawlogs.time as timestamp FROM rawlogs LIMIT 100',
  VIEW_PROJECTION_TIME_FIELD: 'event_timestamp',
  TABLE_PAGE_SIZE: 25,
  EXTERNAL_PROJECTION_TABLE: 'rawlogs',
  VIEW_PROJECTION_TIMESTAMP_NAME: 'event_timestamp',
} as const;
